import { FileUploader } from "@scrile/tools/dist/lib/FileUploader";
import config from "../config";

const fileUploader = new FileUploader(config.s3Url);

export default fileUploader;
